import React from 'react'
import { EditBillRateFlowProvider } from './context/EditBillRateFlowProvider'
import { EditBillRateFlowMain } from './components/EditBillRateFlowMain'
import { useBillRatesWorkflowsContextValue } from '../../context/BillRatesWorkflowsProvider'

export const EditBillRateFlow = () => {
  const { editBillRateFlow } = useBillRatesWorkflowsContextValue()

  if (!editBillRateFlow.billRate) {
    return null
  }

  return (
    <EditBillRateFlowProvider>
      <EditBillRateFlowMain billRate={editBillRateFlow.billRate} />
    </EditBillRateFlowProvider>
  )
}
